// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.2-next',
  revision: 'd45949b38',
  branch: 'next',
  date: 'Wed, 17 Jun 2026 06:48:41 GMT'
};